<template lang="html">
<div>
  <Nav></Nav>

  <div class="container">
    <div class="buttons">
      <b-button
        v-for="(value, id) in liveTraces"
        :key="id"
        size="is-large"
        type="is-danger"
        @click="joinTrace(id)">
        {{ value.short_name }} (trace {{ id }})
      </b-button>
    </div>
  </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
import Nav from '@/components/Nav'
import LiveTrace from '@/models/LiveTrace'
import TracePeer from '@/components/TracePeer'

export default {
  components: {
    Nav
  },
  data () {
    return {
      activeTrace: ''
    }
  },
  computed: {
    ...mapState({
      id: state => state.auth.id,
      liveTraces: state => state.entities.livetraces.data
    })
  },
  methods: {
    joinTrace (traceId) {
      // Peer ID is the websocket channel name of the host.
      console.log('join trace', traceId)

      const liveTrace = LiveTrace.find(traceId)
      console.log(liveTrace)

      // Open trace peer modal.
      this.$buefy.modal.open({
        component: TracePeer,
        parent: this,
        trapFocus: true,
        canCancel: true,
        // onCancel: this.abort,
        hasModalCard: true,
        fullScreen: true,
        props: {
          trace: liveTrace
        },
        events: {
          abort: () => {
            this.abort()
          },
          save: () => {
            this.stop()
          }
        }
      })
    }
  }
}
</script>
